import { Button } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import React, { useEffect } from "react";
import { Form } from "react-final-form";
import { useDispatch } from "react-redux";
import MakeAsyncFunction from "react-redux-promise-listener";
import { appActions } from "../../../../actions/app.actions";
import {
  ADD_CLIENT_ERROR,
  ADD_CLIENT_REQUEST,
  ADD_CLIENT_RESPONSE,
} from "../../../../actions/clients.actions";
import { history } from "../../../../helpers/history";
import { promiseListener } from "../../../../helpers/store";
import ClientsForm from "./ClientsForm";

export default function ClientsNew() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(appActions.setNextPage("/thermo/clients"));
  }, [dispatch]);
  return (
    <div>
      <MakeAsyncFunction
        listener={promiseListener}
        start={ADD_CLIENT_REQUEST}
        resolve={ADD_CLIENT_RESPONSE}
        reject={ADD_CLIENT_ERROR}
      >
        {(onSubmit) => (
          <Form
            onSubmit={(form) => {
              onSubmit(form).then(() => history.push("/thermo/clients"));
            }}
            mutators={{
              setValue: ([field, value], state, { changeValue }) => {
                changeValue(state, field, () => value);
              },
            }}
            render={({ handleSubmit, submitting, form }) => (
              <form onSubmit={handleSubmit}>
                <ClientsForm setValue={form.mutators.setValue} />

                <Box mt={1} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={submitting}
                  >
                    Ajouter
                  </Button>
                </Box>
              </form>
            )}
          />
        )}
      </MakeAsyncFunction>
    </div>
  );
}
